/**
 * @Email: azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @JobTitle: Full Stack Developer
 *
 * NotInformation Component
 *
 * This component displays a warning or informational message when no data is available,
 * typically used to indicate empty states or no search results.
 *
 * @param {string} text - Default text message to display when no information is available.
 * @param {boolean} card - Whether to render the component with a card background style.
 * @param {React.ReactNode} children - Child elements to render inside the component.
 * @param {boolean} [showButton=false] - Whether to show an optional action button.
 * @param {string} [buttonId=''] - The ID of the button element (for accessibility or testing).
 * @param {string} [buttonUrl=''] - URL to navigate to when the button is clicked.
 * @param {function} [buttonOnclick=null] - Callback function to execute when the button is clicked.
 * @param {string} [buttonTrans=''] - Translated button label.
 * @param {boolean} [searchElement=false] - Indicates if the message relates to a search result (to render appropriate text).
 * @param {string} className - Additional classNames for styling the div container.
 * @param {string} classNameImage - Additional classNames for styling the image.
 * @returns {JSX.Element} A warning or no-information message with optional actions.
 */
import React from 'react';
import warning from '../assets/warningImage.png';
import CustomButtonLink from "./buttons/CustomButtonLink";
import { useTranslation } from "react-i18next";

const NotInformation = ({ text, card, children, showButton = false, buttonId = '',
    buttonUrl = '', buttonTrans = '', searchElement = false, buttonOnclick = null,
                            className='', classNameImage='', containerRef }) => {

    const { t } = useTranslation();

    const message = searchElement ? t('no_results_found') : text;

    return (
        <div className={`content_warning ${card ? ' back_card' : ''} ${className}`} ref={containerRef}>
            <div className='info_waring'>
                <img className={classNameImage} src={warning} alt='' />

                {Boolean(message) && (
                    <div className="warning-text">
                        <p>{message}</p>
                    </div>
                )}

                {showButton &&
                    <CustomButtonLink
                        splitName={false}
                        id={buttonId}
                        card={true}
                        url={buttonUrl}
                        onClick={buttonOnclick}
                        name={buttonTrans}
                    />
                }

                {children}
            </div>
        </div>
    );
};

export default NotInformation;


